import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Travel, TravelInfo } from 'src/app/models/travel';

@Component({
  selector: 'modal-travel-info',
  templateUrl: './modal-travel-info.component.html',
  styleUrls: ['./modal-travel-info.component.scss'],
})
export class ModalTravelInfoComponent implements OnInit {

  @Input() travel: Travel = {} as Travel;

  form: FormGroup;

  constructor(
    private modal: ModalController,
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      fromAddress: [null],
      toAddress: [null],
      fromName: [null],
      toName: [null],
      goodsDescription: [null],
      specialInstructions: [null],
      adrClass: [null],
      adrNumber: [null],
    });
  }

  ngOnInit() {
    this.form.patchValue({
      fromAddress: this.travel.fromAddress || null,
      toAddress: this.travel.toAddress || null,
      fromName: this.travel.fromName || null,
      toName: this.travel.toName || null,
      goodsDescription: this.travel.goodsDescription || null,
      specialInstructions: this.travel.specialInstructions || null,
      adrClass: this.travel.adrClass || null,
      adrNumber: this.travel.adrNumber || null,
    });
  }

  async onSubmit() {
    const raw = this.form.getRawValue();
    const info: TravelInfo = {};
    Object.keys(raw).forEach(key => {
      const val = raw[key];
      info[key] = val && val.trim() !== '' ? val.trim() : null;
    });
    await this.modal.dismiss(info);
  }

  async close() {
    await this.modal.dismiss();
  }
}
